"use strict";
printableSummary.classy.controller({
	name: "PrintableLetterController",
	inject: ["$scope", "$sce", "$q", "$stateParams",
		"ApplicationService", "CalculationService", 
		"authServiceFactory", "HistoryDataModelService"],
	init: function()
	{
		var self = this;
		this.$scope.CalculationService = this.CalculationService;
		this.$.loading = false;
		this.$.$sce = this.$sce;

		$(".off-canvas-wrap").removeClass("off-canvas-wrap");
		// hotfixes for page-break-after in chrome
		$(".ng-scope").css("float", "none");
		$("body").css("float", "none");
		$("html").css("float", "none");

        this.authServiceFactory.check();
        var applicationID = this.$stateParams.applicationID;
        var letterID = this.$stateParams.letterID;

        var applicationData = this.ApplicationService.getData(this.$stateParams.applicationID);

		this.$q.all([applicationData]).then(function(result) {
			self.$.data = self.ApplicationService.getAwardData()['awardLetters'];
			for (var i = 0;  i < self.$.data.length; i++) {
	        	if (Number(self.$.data[i].recordID) == letterID) {
	        		self.$.item = self.$.data[i];
	        	}
	        }
		});
	},
	printClick: function()
	{
		$("#export-content").wordExport();
	},
	toInt: function(num) {
		if (typeof num == "undefined") 
			return 0;
		else return parseInt(num);
	}
});
